import script from "./InquiryDetailDescriptionSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryDetailDescriptionSection.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryDetailDescriptionSection.vue?vue&type=style&index=0&id=13813ada&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13813ada"]])

export default __exports__